import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    menuButton: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
}));
